import { createBrowserRouter } from "react-router-dom";
import protectedRouter from "./protectedRouter";
import otherRouter from "./otherRouter";
import authRouter from "./authRouter";

export const router = createBrowserRouter([
  ...otherRouter,
  ...authRouter,
  ...protectedRouter,
]);
